import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewChild, ElementRef, Output, QueryList } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from 'src/app/services/navigation.service';
import { ExcelService } from 'src/app/services/excel.service';
import { Session } from 'protractor';
import { ZoneService } from 'src/app/services/zone.service';
import { EventEmitterService } from 'src/app/services/event-emitter.service';
import { EventBiService } from 'src/app/services/event-bi.service';
import { EventCapacitacionService } from 'src/app/services/event-capacitacion.service';
import { EventCargaMasivaService } from 'src/app/services/carga-masiva.service';
import { EventNavbarService } from 'src/app/services/event-navbar.service';
import { EventYearService } from 'src/app/services/event-year.service';
import { EventYearCalendarService } from 'src/app/services/event-yearCalendar.service';
import { EventMonthService } from 'src/app/services/event-month.service';
import { ContratistasService } from 'src/app/services/contratistas.service';
import { EmpresasService } from 'src/app/services/empresas.service';
import { ZonasService } from 'src/app/services/zonas.service';
import { IndicadoresService } from 'src/app/services/indicadores.service';
import { EventMantenedoresService } from 'src/app/services/event-mantenedores.service';
import { EventAprobacionMasivaService } from 'src/app/services/event-aprobacion-masiva.service';
import { UserService } from 'src/app/services/user.service';
import { range, Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';
import { ROL } from 'src/app/utils/constants';
import { CategoryService } from 'src/app/services/category.service';
import { EjecutorService } from 'src/app/services/ejecutor.service';
import { Console } from 'console';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ValidationService } from '../../services/validation.service';
import { LoginService } from '../../services/login.service';


@Component({
	selector: 'app-capacitaciones',
	templateUrl: './capacitaciones.component.html',
	styleUrls: ['./capacitaciones.component.scss']
})
export class CapacitacionesComponent implements OnInit {
	flagBi = false;
	flagCapacitaciones = false;
	actualView = 'calendar';
	rolid: any ;
	filterAno: string = "";
	filterMes: string = "";
	dtTriggerUsuario: Subject<any> = new Subject();
	userIdSelected: number;
	zonaIdSelected: number;
	confirmationModalTittle: string;
	confirmationModalMessage: string;
	confirmationModalHasComment = false;
	confirmationModalHasOptions = false;
	confirmationModalisCommentObligatory = false;
	confirmationModalOptionLabel: string;
	usuarioSelected: any;
	zonaSelected: any;
	categoriaSelected: any;
	confirmationModalOptions: { label: string, value: any }[];
	loadingUsuarios = false;
	loadingZonas = false;
	confirmationModalAccept: any;
	message = '';
	flagCargaMasiva = false;
	isIndicatorsCollapsed = false;
	indicatorRealizadas = 'indicator-card';
	indicatorPlanificadas = 'indicator-card';
	indicatorReforzamiento = 'indicator-card';
	showIndicators = false;
	zonasMantenedor: any;
	zonas: any;
	categorias: any;
	ejecutores: any;
	userZonas: any;
	focoCategorias: any;
	relatorEjecutores: any;
	allZonas: any;
	allCategorias: any;
	allEjecutores: any;
	contratistas: any;
	usuarios: any;
	visible = false;
	usuario: any;
	zona: any;
	categoria: any;
	enfoque: any;
	ejecutor: any;
	relator: any;
	foco: any;
	empresas: any;
	indicadores: any;
	year = new Date().getFullYear();
	flagRealizadas = false;
	flagPlanificadas = false;
	flagUsuarios = true;
	flagZonas = false;
	flagCategorias = false;
	flagEnfoques = false;
	flagEjecutores = false;
	flagFocos = false;
	flagRelatores = false;
	flagPlanificacion = false;
	flagReforzamiento = false;
	creationMode: string;
	anioSelected: string = "";
	mesSelected: string = "";
	tipoCapacitacionSelected: string = "";
	searchText: any;
	rows: any;
	page = 0;
	pageSize = 50;
	totalAmmount: number;
	loading = false;
	month = "";
	contratista = "";
	empresa = "";

	constructor(private navigationService: NavigationService,
		private zonasService: ZonasService,
		private contratistasService: ContratistasService,
		private empresasService: EmpresasService,
		private userService: UserService,
		private eventNavbarService: EventNavbarService,
		private eventYearService: EventYearService,
		private eventMonthService: EventMonthService,
		private eventEmitterService: EventEmitterService,
		private validationService: ValidationService,
		private eventYearCalendarService: EventYearCalendarService,
		private loginService: LoginService) { }

	async ngOnInit() {

		await this.loginService.obtenerPermisosMenu('planificacion').then((response) => {
			this.rolid = response.data.rolId
		  })

		$("#show-loading").css('display', 'grid')

		this.rows = [{
			cells: [{
				id: 1, zona: "test", empresa: "1", contratista: "Contratista",
				tipo: "t", nombre: "nombre", categoria: "categoria", foco: "foco",
				ejecutor: "eje", mes: "1", estado: "abierto"
			}]
		}];

		this.anioSelected = "0";
		this.mesSelected = "0";
		this.zonaSelected = "0";
		this.tipoCapacitacionSelected = "0";
		this.openNavbar();
		this.flagBi = true;
		this.flagCapacitaciones = true;
		// this.getZonas();
		// console.log(this.zonas);
		// this.getEmpresas();
		// this.getContratistas();

		if (!sessionStorage.getItem('foo')) {
			sessionStorage.setItem('foo', 'no reload');
			// location.reload();
		} else {
			sessionStorage.removeItem('foo');
		}
		if (!this.navigationService.getValidLogin()) { this.navigationService.goTo('/login'); }

		$("#show-loading").css('display', 'none')
	}

	changeView(view: string): void {
		this.actualView = view;

		if (this.actualView == 'calendar') {
			this.indicatorRealizadas = 'indicator-card';
			this.indicatorPlanificadas = 'indicator-card';
			this.indicatorReforzamiento = 'indicator-card';
		}
		else {
			this.filterAno = '';
			this.filterMes = '';
		}
	}

	filterMonth(month: string) {
		this.changeMonth(month);
	}

	filterYear(year: string) {
		this.changeYear(year);
	}

	filterZone(zone: string) {
	}

	filterContratista(contratista: string) {
	}

	filterEnterprise(empresa: string) {
	}
	getZonas(): any {
		return new Promise((resolve, reject) => {
			this.zonasService.getZonas()
				.then(response => {
					this.zonas = response;
				})
				.catch(error => reject(error));
		});
	}
	getContratistas(): any {
		return new Promise((resolve, reject) => {
			this.contratistasService.getContatistas()
				.then(response => {
					this.contratistas = response;
				})
				.catch(error => reject(error));
		});
	}
	
	getEmpresas(): any {
		return new Promise((resolve, reject) => {
			this.empresasService.getEmpresas()
				.then(response => {
					this.empresas = response;
				})
				.catch(error => reject(error));
		});
	}
	changeYear(year: string) {
		this.filterAno = year;
		this.eventYearService.onYearChange(year);
		this.eventYearCalendarService.onYearChange(year);
		this.eventEmitterService.onCalendarRefresh();
	}
	generateArrayOfYears() {
		var max = Number(this.year) + 3;
		var min = max - 6
		var years = []

		for (var i = max; i >= min; i--) {
			years.push(i)
		}
		return years
	}
	changeMonth(month: string) {
		const months = new Array("Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre")
		this.filterMes = month == '' ? '' : months[parseInt(month) - 1];
		this.eventMonthService.onMonthChange(month == '' ? '' : parseInt(month).toString());
	}

	openNavbar() {
		this.eventNavbarService.openNavbar();
	}

	isIconActiveSend(capacitacion: any): boolean {
		return this.validationService.isActiveIconSend(capacitacion, String(this.rolid));
	}

	isIconActiveDelete(capacitacion: any): boolean {
		return this.validationService.isActiveIconDelete(capacitacion, String(this.rolid));
	}

	isIconActiveEdit(capacitacion: any): boolean {
		return this.validationService.isActiveIconEdit(capacitacion);
	}

	isIconActiveAccept(capacitacion: any): boolean {
		// return this.validationService.isActiveIconAccept( capacitacion);
		return (this.validationService.canAcceptOrReject(capacitacion, String(this.rolid)) || this.validationService.canClose(capacitacion, String(this.rolid)))
	}

	isIconActiveReject(capacitacion: any): boolean {
		return this.validationService.isActiveIconReject(capacitacion, String(this.rolid));
	}

}
